import type { ReactNode } from "react";
import { BrandMark } from "@/shared/ui";

/** Full-screen, chrome-less frame for the auth routes (no app sidebar). */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="grid min-h-screen place-items-center bg-canvas p-6">
      <div className="flex w-full max-w-[400px] flex-col items-center gap-8">
        <BrandMark size={40} />
        {children}
      </div>
    </div>
  );
}
